export default "__VITE_ASSET__CD_SGNyk__"